import React, { useState } from "react";
import TutorialTip from "../componentLibrary/TutorialTip";
import Button from "../componentLibrary/Button";
import { useAuth } from "../contexts/AuthContext";
import { usePageTitle } from "../hooks/usePageTitle";
import FeedbackModal from "./FeedbackModal";

interface FooterProps {
  pageTitle?: string;
  lessonId?: string;
  moduleId?: string;
}

export default function Footer({ pageTitle, lessonId, moduleId }: FooterProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    pageTitle: hookPageTitle,
    lessonId: hookLessonId,
    moduleId: hookModuleId,
  } = usePageTitle();

  // Check if user is authenticated
  const { isAuthenticated: isAuth } = useAuth();

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  // Use hook data with prop fallbacks
  const pageInfo = {
    lessonId: lessonId || hookLessonId,
    moduleId: moduleId || hookModuleId,
    pageTitle: pageTitle || hookPageTitle || "Page",
  };

  return (
    <>
      <footer className="py-0 bg-gray-100 fixed bottom-0 left-0 right-0 z-40 w-full pb-[env(safe-area-inset-bottom)]">
        <div
          className={`flex items-center max-w-md lg:max-w-2xl mx-auto px-2 py-0.5 ${isAuth ? "justify-between" : "justify-center"}`}
        >
          <div className={`text-gray-700 text-sm ${isAuth ? "pl-8" : ""}`}>
            &copy; 2025, Psych For Life
          </div>
          {isAuth && (
            <TutorialTip
              direction="topright"
              tutorialId="footer-feedback-tutorial"
              maxWidth={250}
              content={
                <div className="text-sm">
                  <p className="font-medium mb-2">Share Your Feedback</p>
                  <p>
                    Help us improve by sharing your thoughts about this page or
                    feature.
                  </p>
                </div>
              }
            >
              <Button
                onClick={handleOpenModal}
                variant="primary"
                roundedFull
                size="xs"
                className="px-3 py-0 text-xs"
                aria-label="Give feedback for this page"
              >
                Give Us Feedback
              </Button>
            </TutorialTip>
          )}
        </div>
      </footer>
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        pageTitle={pageInfo.pageTitle}
        lessonId={pageInfo.lessonId}
        moduleId={pageInfo.moduleId}
      />
    </>
  );
}
